<div class="version__container">
  <p>
    {{ 'V' + version }}
  </p>
</div>
